<template>
    <div class="form-post-creator">
        <section class="publish-date">
            <label>Date de publication <span v-if="updateFormData.planifiedDate" @click="$emit('restoreFormData','planifiedDate')" class="restore">Annuler les modifications</span></label>
            <div class="content-section">
                <SelectComponent :changeValueSelect="changeSelectPublishDate" :data="{now:'Maintenant',flanified:'Planifier'}" :valueSelect="!formData.planifiedDate.date ? 'now' : 'flanified'" :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="input-date" v-if="formData.planifiedDate.date">        
                    <p>{{ formatInputDatePicker }}</p>
                    <i class="fa-regular fa-calendar"></i>
                    <input type="date" v-model="formData.planifiedDate.date" :disabled="formData.planifiedDate.date ? false : true" @click="(e)=>e.target.showPicker()" :min="new Date().toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')">
                </div>
                <div class="input-hours" v-if="formData.planifiedDate.hours !== false">
                    <input type="text" v-model="formData.planifiedDate.hours" @blur="comptetePlanifiedDateHours()">
                    <i class="fa-regular fa-clock"></i>
                </div>
            </div>
        </section>
        <section class="content-post">
            <label>Contenu <span v-if="updateFormData.textContent" @click="$emit('restoreFormData','textContent')" class="restore">Annuler les modifications</span></label>
            <Editor
                :id="'contentPost'"
                @setMention="(id,mention)=>{
                    $set(this.formData.mentions, id, mention)
                    $emit('saveFormData')
                }"
                @setText="(text)=> {
                    $set(this.formData, 'textContent', text)
                    $emit('saveFormData')
                }"
                :mentions="this.formData.mentions"
                :text="this.formData.textContent"
                :maxCharacters="maxCharactersText"
                :textInfoMaxCharacters="Object.entries(maxCharactersByNetworkForText).filter(([network,maxCharacters]) => networksSelected.has(network) && maxCharacters !== Infinity).map(value => `<span>${value[0].charAt(0).toUpperCase() + value[0].slice(1)}: ${value[1]}`).join('<br>')"
            />
        </section>
        <section class="content-media">
            <label>Medias <span v-if="updateFormData.files" @click="$emit('restoreFormData','files')" class="restore">Annuler les modifications</span></label>
            <div class="container-medias">
                <input
                    v-validate="''"
                    name="file"
                    type="file"
                    id="file"
                    ref="inputMediaPostCreator"
                    @change="selectFiles"
                    :multiple="true"
                    @click="()=>{}"
                    :accept="`video/*, image/*, application/pdf`"
                    hidden
                >
                
                <input
                    v-validate="''"
                    name="file"
                    type="file"
                    id="file"
                    ref="inputVideoPreview"
                    @change="selectVideoPreview"
                    :multiple="false"
                    @click="()=>{}"
                    :accept="`image/*`"
                    hidden
                >

                <div class="btn-add-media">
                    <ContextMenu :options="[{label:'Ajouter une url',name:'link'},{label:'Importer des fichiers',name:'file'}]" :id="'btnAddMediaPostCreator'" v-on:clickOption="clickBtnAddMedia">
                        <i class="fa-solid fa-photo-film"></i>
                    </ContextMenu>
                </div>

                <draggable class="list-media hide-scrollbar" ref="listMedia" v-model="formData.files" v-bind="dragOptions" @start="drag=true" @end="drag=false" :move="moveFileMedia">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        
                        <Tooltip v-for="media in formData.files" 
                            :active="
                                    (!uploadFilesServer[media.id] || (!uploadFilesServer[media.id].isUpload && !uploadFilesServer[media.id].uploadProgress)) ||
                                    (!uniqueNetworkForm && !uploadFilesServer[media.id].uploadProgress && Object.keys(media.errorNetwork).length && Object.keys(media.errorNetwork).some(networkName => networksSelected.has(networkName))) ||
                                    (uniqueNetworkForm && !uploadFilesServer[media.id].uploadProgress && typeRenderNetworkSelected && media.errorNetwork.hasOwnProperty(typeRenderNetworkSelected))
                            " 
                            :text="
                                (!uploadFilesServer[media.id] || (!uploadFilesServer[media.id].isUpload && !uploadFilesServer[media.id].uploadProgress)) ?
                                    'Echec du chargement du media'
                                : 
                                    (uniqueNetworkForm && typeRenderNetworkSelected && !uploadFilesServer[media.id].uploadProgress && media.errorNetwork[typeRenderNetworkSelected]) ?
                                        `<b>${typeRenderNetworkSelected.charAt(0).toUpperCase() + typeRenderNetworkSelected.slice(1)} :</b><br>${Object.values(media.errorNetwork[typeRenderNetworkSelected]).join('<br>')}`
                                    :
                                        (!uniqueNetworkForm && !uploadFilesServer[media.id].uploadProgress && Object.keys(media.errorNetwork).length && Object.keys(media.errorNetwork).some(networkName => networksSelected.has(networkName))) ?
                                            Object.keys(media.errorNetwork).reduce((newArray, networkName) => {
                                                if (networksSelected.has(networkName))
                                                    newArray.push(`<b>${networkName.charAt(0).toUpperCase() + networkName.slice(1)} :</b><br>${Object.values(media.errorNetwork[networkName]).join('<br>')}`)
                                                    return newArray
                                                },[]).join('<br><br>')
                                        : ''
                            " 
                           
                            position="bottom"
                            :key="media.id" 
                            classCustom="item-draggable">
                          
                            <i class="fa-solid fa-circle-xmark" @click="removeFile(media.id)"></i>
                            <div class="media-container picture" v-if="['image/png','image/jpeg','image/gif'].includes(media.type)" :key="`image${media.id}`">
                                <div class="media picture" :media="media.id">
                                    <img draggable="false" :src="media.url" alt="" class="source">
                                </div>
                            </div>
                            <div class="media-container video" v-else-if="['video/mp4'].includes(media.type)" :key="`video${media.id}`">
                                <div class="media video" :media="media.id"> 
                                    <!--  @mouseover="playVideoMedia" @mouseup="playVideoMedia" @mouseleave="pauseVideoMedia" @mousedown="pauseVideoMedia" -->
                                    <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                        <source :src="media.url" type="video/mp4">
                                    </video>

                                    <img v-if="media.imagePreview" :src="media.imagePreview.url" alt="" class="preview" draggable="false" @click="clickBtnAddVideoPreview(media.id)">
                                    <video v-else muted playsinline preload="metadata" class="preview" @click="clickBtnAddVideoPreview(media.id)" onloadedmetadata="this.muted = true">
                                        <source :src="media.url" type="video/mp4">
                                    </video>
                                </div>
                            </div>
                            <div class="media-container pdf" v-else-if="['application/pdf'].includes(media.type)" :key="`pdf${media.id}`">
                                <div class="media pdf" :media="media.id">
                                    <div class="container-svg">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 36 44" fill="none"><path d="M4.31826 0H25.0017C25.2296 0.0296647 25.4589 0.0524506 25.6853 0.0904987C26.6275 0.249355 27.4586 0.654342 28.1394 1.31148C30.3569 3.45192 32.5639 5.60247 34.7602 7.76311C35.2913 8.28289 35.6901 8.88994 35.8815 9.61694C35.9883 10.0221 36.0002 10.4353 36 10.8519C35.9978 20.3622 35.996 29.8725 35.9946 39.3828C35.9974 39.7155 35.966 40.0475 35.9007 40.3738C35.6321 41.6494 34.9343 42.6408 33.8246 43.3332C33.1277 43.773 32.3182 44.0044 31.4927 43.9996C22.4808 43.9967 13.4688 43.9967 4.45688 43.9996C3.95217 43.9991 3.45185 43.9064 2.98092 43.7259C1.15872 43.0374 0 41.3676 0 39.4293C0 27.8178 0.00115338 16.2056 0.00346015 4.59286C0.00461999 4.29972 0.0317573 4.00724 0.0845573 3.71883C0.424084 1.84136 1.95498 0.357481 3.8399 0.0659931C3.99885 0.0414875 4.15866 0.0214961 4.31826 0ZM34.508 25.0961C34.508 20.3765 34.508 15.657 34.508 10.9374C34.508 10.7655 34.5067 10.5935 34.492 10.4226C34.4659 10.1189 34.4224 9.81836 34.2641 9.54751C34.102 9.26419 33.9023 9.00389 33.6702 8.77365C31.7438 6.89417 29.8174 5.01576 27.8911 3.13844C27.6007 2.85512 27.3187 2.56169 27.0123 2.29643C26.3395 1.71432 25.5344 1.48861 24.657 1.48861C17.9789 1.4876 11.3008 1.4876 4.62254 1.48861C3.77913 1.48861 3.03822 1.75645 2.42859 2.34222C1.77332 2.97034 1.49024 3.75215 1.49046 4.65069C1.4919 16.2241 1.49269 27.7974 1.49284 39.3706C1.49123 39.5459 1.50243 39.7212 1.52636 39.8949C1.67774 40.9205 2.21363 41.6847 3.12927 42.1795C3.61088 42.4398 4.13293 42.5303 4.67941 42.5301C13.5296 42.5275 22.3799 42.5269 31.2302 42.5282C31.331 42.5282 31.432 42.5282 31.533 42.5252C32.4668 42.4886 33.2371 42.1167 33.8283 41.3966C34.3078 40.813 34.5082 40.132 34.508 39.3837C34.5062 34.621 34.5058 29.8585 34.5069 25.0961H34.508Z" fill="#fff"></path><path d="M18.7277 11.049C18.7127 12.0105 18.5568 12.9146 18.3295 13.808C18.1805 14.3934 18.0268 14.9774 17.8719 15.5615C17.8626 15.5933 17.8602 15.6268 17.8648 15.6597C17.8694 15.6926 17.8809 15.7242 17.8985 15.7523C18.5004 16.8231 19.2651 17.7777 20.0347 18.7291C20.222 18.9606 20.4106 19.1913 20.597 19.4243C20.6349 19.4718 20.6703 19.486 20.7337 19.4778C21.3721 19.3955 22.0096 19.3059 22.6504 19.2414C23.497 19.1554 24.3463 19.1238 25.1938 19.2358C25.681 19.3003 26.1572 19.4078 26.588 19.6584C27.0839 19.946 27.3733 20.3596 27.3824 20.9467C27.3882 21.3336 27.2269 21.6311 26.9137 21.8495C26.6079 22.0645 26.2574 22.1539 25.8921 22.1909C24.919 22.2893 23.9962 22.0722 23.1024 21.7117C22.1762 21.337 21.3292 20.7923 20.6059 20.106C20.5282 20.0327 20.4619 20.0157 20.3587 20.0374C19.299 20.2594 18.2394 20.4757 17.2052 20.7958C16.6429 20.9699 16.0841 21.1584 15.5253 21.3448C15.4767 21.3648 15.4355 21.3994 15.4074 21.4437C14.9927 22.067 14.5908 22.7003 14.1657 23.317C13.5677 24.1842 12.9114 25.0045 12.1075 25.6969C11.5965 26.1369 11.0167 26.4374 10.3427 26.5419C10.0506 26.5908 9.75106 26.5724 9.46724 26.4882C9.00423 26.3476 8.56284 25.8407 8.62383 25.2878C8.6554 25.0017 8.78062 24.7549 8.94649 24.5256C9.25098 24.1045 9.645 23.7758 10.0622 23.4723C10.8269 22.9172 11.6649 22.4882 12.5109 22.0731C12.9849 21.8405 13.4589 21.6077 13.9304 21.3699C13.9862 21.3409 14.0315 21.2954 14.0601 21.2397C15.0296 19.1898 15.9146 17.1017 16.6948 14.9705C16.7168 14.9012 16.7168 14.8268 16.6948 14.7575C16.4909 14.1176 16.2517 13.4871 16.0787 12.8392C15.8438 11.9554 15.7439 11.0415 15.7822 10.1281C15.7899 9.88861 15.8224 9.65054 15.8791 9.41765C16.0804 8.62229 16.8538 8.26589 17.6031 8.61198C18.1319 8.85617 18.4217 9.29211 18.5776 9.83167C18.6959 10.2412 18.7186 10.6621 18.7277 11.049ZM17.5832 16.1831C17.0742 17.748 16.444 19.2399 15.7855 20.7403C17.2128 20.239 18.6688 19.8751 20.1881 19.6036C19.2251 18.5157 18.3509 17.4041 17.5832 16.1831ZM21.0079 19.8914C21.0451 19.9213 21.0609 19.9344 21.0775 19.9473C22.0291 20.652 23.1 21.1161 24.2237 21.4701C24.5161 21.5623 24.8138 21.6296 25.124 21.6165C25.5712 21.5978 25.9483 21.2994 26.0348 20.8964C26.1183 20.5094 25.9124 20.1057 25.5067 19.9136C25.31 19.8186 25.1024 19.7477 24.8885 19.7023C24.3595 19.5948 23.8193 19.6019 23.2853 19.6378C22.6292 19.6818 21.9763 19.7704 21.3221 19.8413C21.2242 19.8517 21.1281 19.8721 21.0079 19.8914ZM13.4959 22.1195L13.4758 22.1008C13.3158 22.181 13.1553 22.2605 12.9955 22.3409C12.223 22.7304 11.4374 23.0959 10.7051 23.56C10.2306 23.8609 9.77281 24.1833 9.39847 24.6068C9.2553 24.7691 9.1316 24.9445 9.06802 25.1545C8.91664 25.6556 9.34484 26.1126 9.85521 25.983C10.3076 25.8682 10.691 25.6225 11.0254 25.3035C11.8165 24.5486 12.4719 23.684 13.0749 22.7777C13.2191 22.561 13.3558 22.3394 13.4959 22.1195ZM16.9487 14.1055C16.9658 14.0937 16.9747 14.0911 16.9768 14.0858C16.9846 14.066 16.9905 14.0451 16.9967 14.0247C17.3354 12.9297 17.6059 11.8192 17.7091 10.6756C17.7372 10.3646 17.7193 10.0466 17.6918 9.73429C17.679 9.58768 17.6289 9.41787 17.5356 9.30931C17.1784 8.89293 16.7095 8.90991 16.4375 9.41679C16.4241 9.44216 16.4105 9.46731 16.399 9.49353C16.2861 9.74912 16.2374 10.0189 16.2232 10.2956C16.1951 10.8315 16.2772 11.3583 16.3529 11.8863C16.4611 12.6483 16.7102 13.3706 16.9487 14.1055Z" fill="#fff"></path><path d="M15.7803 37.7018V30.9759C15.8058 30.9716 15.8316 30.9687 15.8575 30.9673C16.4732 30.972 17.0902 30.9608 17.7041 30.9871C18.3109 31.0131 18.8829 31.17 19.365 31.5657C19.794 31.9176 20.057 32.3776 20.2106 32.8985C20.536 34.0053 20.4904 35.1014 20.0239 36.1595C19.7229 36.8422 19.2253 37.3437 18.4846 37.5653C18.1697 37.6562 17.8435 37.7026 17.5155 37.7029C16.961 37.7087 16.4063 37.7052 15.8519 37.7057C15.8304 37.7061 15.8099 37.7042 15.7803 37.7018ZM16.9014 36.8043C17.1438 36.8043 17.3752 36.8196 17.6038 36.8013C18.1745 36.7555 18.6156 36.4963 18.8812 35.9782C18.9428 35.8612 18.995 35.7395 19.0374 35.6143C19.28 34.8675 19.2785 34.1096 19.1297 33.3465C19.0583 32.981 18.9197 32.6397 18.6608 32.3605C18.1771 31.8381 17.5447 31.8398 16.9014 31.8682V36.8043Z" fill="#fff"></path><path d="M11.8611 35.0744V37.701H10.7495C10.7478 37.6638 10.7446 37.6264 10.7446 37.5888C10.7446 35.4228 10.7438 33.2569 10.7422 31.0909C10.7422 30.9923 10.7686 30.9643 10.8683 30.9656C11.5343 30.9749 12.2009 30.9656 12.8663 30.9888C13.15 31.0017 13.4314 31.0458 13.7054 31.1204C14.1967 31.2494 14.5137 31.5976 14.7088 32.0432C15.0021 32.713 14.9986 33.3975 14.6902 34.0613C14.4179 34.6477 13.9257 34.9544 13.2906 35.0163C12.8652 35.0578 12.4357 35.0568 12.0082 35.0742C11.9625 35.0759 11.9169 35.0744 11.8611 35.0744ZM11.8695 34.184C12.291 34.1769 12.7086 34.2186 13.1154 34.0948C13.3349 34.0282 13.5153 33.9044 13.605 33.6896C13.7914 33.2442 13.8038 32.7906 13.6007 32.3485C13.4861 32.0991 13.3014 31.8953 13.0069 31.8728C12.6349 31.8444 12.2608 31.8467 11.8875 31.8364C11.8819 31.8364 11.876 31.8442 11.8695 31.8489V34.184Z" fill="#fff"></path><path d="M24.7185 33.8796V34.761H22.6149V37.6978H21.501V30.9727C21.5421 30.971 21.5771 30.968 21.6124 30.968C22.7862 30.968 23.9601 30.9673 25.1341 30.9658C25.2263 30.9658 25.2598 30.9852 25.2572 31.0836C25.25 31.3371 25.2548 31.5909 25.2548 31.8575H22.6164C22.6138 31.9026 22.6102 31.9366 22.6102 31.9708C22.6102 32.5686 22.6121 33.1664 22.6078 33.7642C22.6078 33.8609 22.6368 33.8833 22.7302 33.8826C23.3459 33.8785 23.9616 33.8807 24.5775 33.8807L24.7185 33.8796Z" fill="#fff"></path></svg>
                                    </div>
                                    <!-- <pdf  :src="media.url" :page="1"></pdf> -->
                                    <img v-if="media.canvas" draggable="false" :src="media.canvas" alt="" class="source">
                                </div>
                            </div>
                            <div v-if="uploadFilesServer[media.id] && !uploadFilesServer[media.id].isUpload && uploadFilesServer[media.id].uploadProgress" class="containerProgressBar"><div class="progressBar"><div class="bar" :style="{width: `${parseInt(uploadFilesServer[media.id].percentUpload)}%`}"></div></div></div>
                            <i class="fa-solid fa-circle-exclamation"></i>
                        </Tooltip>
              
                    </transition-group>
                </draggable>
            
            </div>
        </section>
        <section class="comment-post">
            <label>Commentaire <span v-if="updateFormData.textComment" @click="$emit('restoreFormData','textComment')" class="restore">Annuler les modifications</span></label>
            <!-- <Textarea v-on:setTextareaValue="setTextareaCommentValue" :showOptionBold="false" :showOptionItalic="false" :showOptionUnderline="false" :ShowCounterCharacters="false"></Textarea> -->
            <Editor
                :id="'contentCommentPost'"
                @setMention="(id,mention)=>{
                    $set(this.formData.mentions, id, mention)
                    $emit('saveFormData')
                }"
                @setText="(text)=> {
                    $set(this.formData, 'textComment', text)
                    $emit('saveFormData')
                }"
                :mentions="this.formData.mentions"
                :text="this.formData.textComment"

                :showOptionBold="false" 
                :showOptionItalic="false" 
                :showOptionUnderline="false" 
                :ShowCounterCharacters="false"
                
            />
        </section>
        <section class="settings-advanced">
            <label>Réglages {{ typeRenderNetworkSelected || networkSetting }} <span v-if="updateFormData.formDataNetwork && updateFormData.formDataNetwork[typeRenderNetworkSelected]" @click="$emit('restoreFormData','formDataNetwork')" class="restore">Annuler les modifications</span></label>
            <p class="sub-label">Chaque réseau a ses exigences et ses paramètres</p>
            <div class="nav-network hide-scrollbar" v-if="false">
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'instagram'}" @click="networkSetting = 'instagram'">
                    <i class="fa-brands fa-instagram"></i>Instagram
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'facebook'}" @click="networkSetting = 'facebook'">
                    <i class="fa-brands fa-facebook"></i>Facebook
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'linkedin'}" @click="networkSetting = 'linkedin'">
                    <i class="fa-brands fa-linkedin"></i>Linkedin
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'threads'}" @click="networkSetting = 'threads'">
                    <svg :style="{height: '15px'}" aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path class="x19hqcy" d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"/></svg>Threads
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'twitter'}" @click="networkSetting = 'twitter'">
                    <i class="fa-brands fa-twitter" style="font-size: 14px;"></i>Twitter
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'tiktok'}" @click="networkSetting = 'tiktok'">
                    <i class="fa-brands fa-tiktok"></i>Tiktok
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'google'}" @click="networkSetting = 'google'">
                    <i class="fa-brands fa-google"></i>My Business
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'pinterest'}" @click="networkSetting = 'pinterest'">
                    <i class="fa-brands fa-pinterest"></i>Pinterest
                </div>
                <div class="btn" :class="{active: typeRenderNetworkSelected == 'youtube'}" @click="networkSetting = 'youtube'">
                    <i class="fa-brands fa-youtube"></i>Youtube
                </div>
            </div>
            <FormInstagram v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'instagram'" :hide="typeRenderNetworkSelected !== 'instagram'" @setFormDataNetwork="setFormDataNetwork" :formData="formData"/>
            <FormFacebook v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'facebook'" :hide="typeRenderNetworkSelected !== 'facebook'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataFacebook="formData.formDataNetwork.facebook"/>
            <FormLinkedin v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'linkedin'" :hide="typeRenderNetworkSelected !== 'linkedin'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataLinkedin="formData.formDataNetwork.linkedin"/>
            <FormThreads v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'threads'" :hide="typeRenderNetworkSelected !== 'threads'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataThreads="formData.formDataNetwork.threads"/>
            <FormTwitter v-if="!uniqueNetworkForm|| typeRenderNetworkSelected == 'twitter'" :hide="typeRenderNetworkSelected !== 'twitter'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataTwitter="formData.formDataNetwork.twitter"/>
            <FormTiktok v-if="!uniqueNetworkForm|| typeRenderNetworkSelected == 'tiktok'" :hide="typeRenderNetworkSelected !== 'tiktok'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataTiktok="formData.formDataNetwork.tiktok"/>
            <FormGoogle v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'google'" :hide="typeRenderNetworkSelected !== 'google'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataGoogle="formData.formDataNetwork.google"/>
            <FormPinterest v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'pinterest'" :hide="typeRenderNetworkSelected !== 'pinterest'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataPinterest="formData.formDataNetwork.pinterest"/>
            <FormYoutube v-if="!uniqueNetworkForm || typeRenderNetworkSelected == 'youtube'" :hide="typeRenderNetworkSelected !== 'youtube'" @setFormDataNetwork="setFormDataNetwork" :formData="formData" :formDataYoutube="formData.formDataNetwork.youtube" :idPageRenderNetworkSelected="idPageRenderNetworkSelected ? idPageRenderNetworkSelected : null"/>
        </section>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from './../../../store/index.js';
import SelectComponent from '../utils/select.vue'
import Editor from './Editor.vue'
import ComponentSwitch from '../utils/switch.vue'
import Checkbox from '../utils/checkbox.vue'
import SnippetNetwork from './SnippetNetwork.vue'
import ContextMenu from '../contextMenu/contextMenuInit.vue'
import draggable from 'vuedraggable'
import minxinBot from '../../mixins/Bots.vue'
import minxinPosts from '../../mixins/Posts.vue'

import FormInstagram from './formNetwork/formInstagram.vue'
import FormFacebook from './formNetwork/formFacebook.vue'
import FormLinkedin from './formNetwork/formLinkedin.vue'
import FormThreads from './formNetwork/formThreads.vue'
import FormTwitter from './formNetwork/formTwitter.vue'
import FormTiktok from './formNetwork/formTiktok.vue'
import FormGoogle from './formNetwork/formGoogle.vue'
import FormPinterest from './formNetwork/formPinterest.vue'
import FormYoutube from './formNetwork/formYoutube.vue'
import pdf from 'pdfvuer'
import { getDocument } from 'pdfjs-dist';
 import { parseGIF, decompressFrames } from 'gifuct-js'
import { formDataDefault } from './constante.js'
import Tooltip from './../tooltip/tooltipInit.vue'

// import * as pdfjsLib from 'pdfjs-dist/webpack';

// // Configure the workerSrc to use the correct version of the worker script
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js`;


export default {
    mixins: [minxinBot, minxinPosts],
    components: {
        Editor,
        SelectComponent,
        ComponentSwitch,
        SnippetNetwork,
        Checkbox,
        Tooltip,
        ContextMenu,
        draggable,
        pdf,
        FormInstagram,
        FormFacebook,
        FormLinkedin,
        FormThreads,
        FormTwitter,
        FormTiktok,
        FormGoogle,
        FormPinterest,
        FormYoutube,
    },
    props: {
        typeRenderNetworkSelected: {
            type: String,
            default: 'facebook'
        },

        idPageRenderNetworkSelected: Number,

        formData :  Object,
        
        updateFormData : {
            type: Object,
            default: () => ({})
        },

        uniqueNetworkForm : {
            type: Boolean,
            default: false
        },

        uploadFilesServer : {
            type: Object,
            default: () => ({})
        },

        networksSelected : {
            type: Set,
            default: () => (new new Set([]))
        },
    },

    data() {
        return {
            maxCharactersByNetworkForText:{
                facebook:63206,
                instagram:2200,
                linkedin:3000,
                threads: 500,
                twitter: 280,
                google:1300,
                tiktok: Infinity,
                telegram: Infinity,
                pinterest: Infinity,
                youtube: Infinity,
            },
            lastModeSelected : undefined,
            networkSetting: 'instagram',
            drag : false,
            timeoutVerifMetaUrl: null
        }
    },

    created () {
        console.log('created form formdata ', this.formData)
    },

    mounted () {
        console.log('mounted form formdata ', this.formData)
    },

    computed: {
        console: () => console,

        formatInputDatePicker() {
            if(this.formData.planifiedDate.date == false) return '';
            let dateNow = new Date()
            let dateFuture = new Date(this.formData.planifiedDate.date)
      
            if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                if (Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24)) < 7) {
                    if (dateFuture.getDay() === dateNow.getDay()) return "Aujourd'hui"
                    if (dateFuture.getDay() === dateNow.getDay()+1) return "Demain"
                    return dateFuture.toLocaleDateString(undefined, { weekday: 'long' });
                }
              
                if(dateFuture.getMonth() === dateNow.getMonth()) return dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric'});

                return dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'numeric' });
            }
            return dateFuture.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric', year: 'numeric' });
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        },

        maxCharactersText() {
            return Math.min(...(Array.from(this.networksSelected).map(network => {
                console.log('okokclem')
                return this.maxCharactersByNetworkForText[network]
            })))
        }

       
    },

    methods: {
        addMode(mode, data = {}) {
            this.lastModeSelected = mode
            EventBus.$emit("postCreatorAddMode", mode, data);
        },
            
        changeSelectPublishDate(value) {
            if (!this.date && value == "flanified") {
                let date = new Date((new Date).getTime() + 3600000)
                this.$set(this.formData.planifiedDate, 'date', date.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-'));
                this.$set(this.formData.planifiedDate, 'hours', date.toLocaleString('fr-FR').split(' ')[1].split(':').slice(0,2).join('h'));
            }else if(value == "now") {
                this.$set(this.formData.planifiedDate, 'date',false)
                this.$set(this.formData.planifiedDate, 'hours', false)
            }  
            

            this.$emit('saveFormData')


        },

        clickBtnAddMedia(id, value) {

            switch (value) {
                case 'link':
                    console.log(Math.min(...([...this.networksSelected].map(network => this.maxCharactersByNetworkForText[network] ? this.maxCharactersByNetworkForText[network] : Infinity))))
                    break;
            
                case 'file':
                    this.$refs.inputMediaPostCreator.click()
                    break;
            }
        },

        async selectFiles(e) {
            let files = []
            for(let i = 0;  i < e.target.files.length; i++) {
                console.log("file add", e.target.files[i])
                
                let file = {
                    id: Math.random().toString(36).substr(2, 9),
                    url: URL.createObjectURL(e.target.files[i]),
                    name:  e.target.files[i].name,
                    type:  e.target.files[i].type,
                    size:  e.target.files[i].size,
                    type2: ['image','video'].includes(e.target.files[i].type.split('/')[0]) ? 
                                e.target.files[i].type.split('/')[0]
                            : ['pdf'].includes(e.target.files[i].type.split('/')[1]) ?
                                e.target.files[i].type.split('/')[1]
                            : null,
                    errorNetwork : {}
                    //ratio: this.carrouselRatio,
                };

                // get dimensions
                if (file.type.startsWith('image/')) {
                    let img = new Image();
                    await new Promise((resolve) => {
                        img.onload = () => {
                            file.dimensions = { 
                                width: img.width,
                                height: img.height,
                                aspectRatio: img.width / img.height
                            };
                            resolve();
                        };
                        img.onerror = () => {
                            file.dimensions = undefined;
                            resolve();
                        };
                        img.src = file.url;
                    });
                }

                if (file.type == 'image/gif') {
                    let buffer = await this.fileToArrayBuffer(e.target.files[i]);
                    let gif = parseGIF(buffer);
                    let frames = decompressFrames(gif, false);
                    file.dimensions = {
                        ...(file.dimensions || {}),
                        framesLength : frames.length
                    }
                }

                // get dimensions
                if (file.type.startsWith('video/')) {
                    let video = document.createElement('video');
                    await new Promise((resolve) => {
                        video.onloadedmetadata = () => {
                            console.error("Error loading image:", file.name);
                            file.dimensions = { 
                                width: video.videoWidth, 
                                height: video.videoHeight,
                                aspectRatio: video.videoWidth / video.videoHeight
                            };
                            resolve();
                        };

                        video.onerror = () => {
                            console.error("Error loading video:", file.name);
                            file.dimensions = undefined; // Set to undefined in case of error
                            resolve();
                        };
                        video.src = file.url;
                    });
                }

                if (file.type === 'application/pdf') {
                    try {
                        let doc = await getDocument(file.url).promise;
                        let page = await doc.getPage(1);
                        file.canvas = (await this.makeThumb(page)).toDataURL();
                    } catch (error) {
                        console.error(error);
                    }
                }

                const addErrorFile = (fileObject, network, property, textError) => {
                    fileObject.errorNetwork[network] = {
                        ...(file.errorNetwork[network] || {}),
                        [property] : textError
                    }
                }

                //////////////////// detect error network ////////////////////
                //size
                const sizeInMo = file.size / (1024 * 1024)
                const maxSizePerNetwork = {facebook:4,twitter:5,instagram:8, google: 5}
                Object.entries(maxSizePerNetwork).forEach(([network, maxSize]) => {
                    if (sizeInMo >= maxSize) {
                        addErrorFile(file,network,'size', `La taille maximum est de ${maxSize}Mo`)
                    }
                });

                //Dimension max
                const maxDimensionPerNetwork = {twitter:'8192x8192',linkedin: 36152320, instagram:'1.91:1'}
                Object.entries(maxDimensionPerNetwork).forEach(([network, dimension]) => {
                    if (Number.isInteger(dimension)) {
                        if (file.dimensions && file.dimensions.width * file.dimensions.height > dimension) {
                            addErrorFile(file,network,'size', `Le media est trop grand et dépasse les dimensions autorisées.`)
                        }

                    }else if(dimension.includes('x')){
                        const [maxWidth,maxHeight] = dimension.split('x')
                        if (file.dimensions && (file.dimensions.width > maxWidth || file.dimensions.height > maxHeight)) {
                            addErrorFile(file,network,'size', `Les dimensions du media ne doivent pas dépasser ${maxWidth} pixels de largeur et ${maxHeight} pixels de hauteur.`)
                        }
                    }else if (dimension.includes(':')) {
                        console.error("Fonctionnalité en cours de développement")
                    }
                });

                //Dimension min
                const minDimensionPerNetwork = {twitter:'4x4',google: '250x250', instagram:'4:5'}
                Object.entries(minDimensionPerNetwork).forEach(([network, dimension]) => {
                    if(Number.isInteger(dimension)){
                        if (file.dimensions && file.dimensions.width * file.dimensions.height < dimension) {
                            addErrorFile(file,network,'size', `Le media est trop petit et n'atteint pas les dimensions autorisées.`)
                        }
                    }else if (dimension.includes('x')) {
                        const [minWidth,minHeight] = dimension.split('x')
                        if (file.dimensions && (file.dimensions.width < minWidth || file.dimensions.height < minHeight)) {
                            addErrorFile(file,network,'size', `Les dimensions du media doivent dépasser ${minWidth} pixels de largeur et ${minHeight} pixels de hauteur.`)
                        }
                    }else if (dimension.includes(':')) {
                        console.error("Fonctionnalité en cours de développement")
                    }
                });


                //max frame gif
                const maxFrameGif= {twitter: 350,linkedin: 250}
                Object.entries(maxFrameGif).forEach(([network, maxFrame]) => {
                    if(Number.isInteger(maxFrame) && file.dimensions && file.dimensions.framesLength){
                        if (file.dimensions.framesLength > maxFrame) {
                            addErrorFile(file,network,'frame', `Le GIF dépasse le nombre maximum de frames autorisées.`)
                        }
                    }
                });


                
                this.$emit('updloadFile',e.target.files[i], file.id)
                files.push(file)
            }
          
            this.$set(this.formData, 'files', [...this.formData.files, ...files])
            //this.$emit('saveFormData') dans le watch
        },

        makeThumb(page) {
            // draw page to fit into 96x96 canvas
            var vp = page.getViewport({ scale: 1, });
            var canvas = document.createElement("canvas");
            var scalesize = 1;
            canvas.width = vp.width * scalesize;
            canvas.height = vp.height * scalesize;
            var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);

            return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
                return canvas; 
            });
        },

        removeFile(id) {
            this.$set(this.formData, 'files', this.formData.files.filter(f =>(f.id !== id)))
            //this.$emit('saveFormData') dans le watch
        },

        clickBtnAddVideoPreview(id) {
            this.$refs.inputVideoPreview.setAttribute('idMedia', id)
            this.$refs.inputVideoPreview.click()
        },

        selectVideoPreview(e) {
   
            let idFile = e.target.getAttribute('idMedia')

            this.$set(this.formData, 'files', this.formData.files.map((file) => {
                if (file.id !== idFile) return file;

                file.imagePreview = {
                    url: URL.createObjectURL(e.target.files[0]),
                    name: e.target.files[0].name,
                    type: e.target.files[0].type,
                    size: e.target.files[0].size,
                    id: Math.random().toString(36).substr(2, 9),
                    // ratio: this.carrouselRatio,
                }
                this.$emit('updloadFile', e.target.files[0], file.imagePreview.id)
                return file
            }));
            //this.$emit('saveFormData')  dans le watch
        },

        moveFileMedia() {
            // console.log("moveFileMedia", this.formData.files[0])
            // this.$nextTick(() => {
            //     this.$emit('saveFormData')
            // })
            //this.$emit('setFormData', this.formData)
        },

        comptetePlanifiedDateHours() {
            let tab = [...this.formData.planifiedDate.hours.split('h').filter(e => e.length),'00','00']
            tab[1] = tab[1].padStart(2, '0') + "0"
            this.formData.planifiedDate.hours = tab.slice(0,2).join('h')
        },
        
        calculTimeStampPlanifiedDate() {
            let date = new Date(this.formData.planifiedDate.date)
            if (this.formData.planifiedDate.hours.includes("h")) {
                let [hours,minute] = [...this.formData.planifiedDate.hours.split('h').filter(e=>e.length),'00','00'].slice(0,2)
                date.setMinutes(minute)
                date.setHours(hours)
            }

            this.$set(this.formData.planifiedDate, 'timestamp', date.getTime());
            this.$emit('saveFormData')
        },

        setFormDataNetwork(typeNetwork, data) {
            console.log('setFormDataNetwork',typeNetwork, this.uniqueNetworkForm)
            if (this.uniqueNetworkForm && typeNetwork !== this.typeRenderNetworkSelected) return
            this.$set(this.formData.formDataNetwork, typeNetwork, data);
            this.$emit('saveFormData')
        },

        playVideoMedia(e) {
            console.log(e)
        },

        getUrlsContent(content) { 
          try {
              const urls = this.unescapeSpecialChars(content).match(/(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:[\/?][^\s]*)?/g); // eslint-disable-line
              return urls ? [...new Set(urls.map(url => ((!/^https?:\/\//i.test(url) ? 'https://' + url  : url)).replaceAll("\\n",'')))] : []
          }catch (error) {
              return []
          }
        },

        unescapeSpecialChars(str) {
            // Remplacer les séquences échappées par leurs équivalents littéraux
            return str
                .replace(/\\n/g, '\n')          // Newline '\n'
                .replace(/\\t/g, '\t')          // Tab '\t'
                .replace(/\\r/g, '\r')          // Carriage return '\r'
                .replace(/\\f/g, '\f')          // Form feed '\f'
                .replace(/\\v/g, '\v')          // Vertical tab '\v'
                .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
                .replace(/\\\\/g, '\\');        // Backslash '\\'
        },

        async fileToArrayBuffer(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();

                reader.onload = function(e) {
                    let arrayBuffer = new Uint8Array(reader.result);
                    resolve(arrayBuffer)
                }

                reader.readAsArrayBuffer(file);
            });
        },
    },

    watch: {
        ["formData.planifiedDate.hours"](newValue, oldValue) {
            // Garde que les chiffres et les lettre h | garde que un seul 'h' | garde que 2 chiffre apres le h
            newValue = newValue.toLowerCase().replace(/^h|[^0-9h]|(h.{2}).*|h(.*?)h/gi, '$1$2');

            if (oldValue.length > newValue.length && oldValue.slice(-1) == "h") newValue = newValue.slice(0,-1)

            let valueSplit = newValue.split("h").slice(0, 2).map((vstr, i) => {
                if (!vstr.length) return vstr;
                if (vstr.length == 2 && vstr[0] == "0") return vstr
                let v = parseInt(vstr);
                v = i ? Math.min(v, 59) : Math.min(v, 23);
        
                return v < 10 ?
                    i && v > 5 ?
                        v.toString().padStart(2, '0')
                        : !i && v > 2 ?
                            v.toString().padStart(2, '0')
                            : v.toString()
                    : v.toString();
            });

            if (new Date().setHours(0,0,0,0) == new Date(this.formData.planifiedDate.date).setHours(0,0,0,0) && valueSplit.length == 2 && valueSplit[1].length == 2) {
                let dateNow = new Date(new Date().getTime() + 600000)
                if (parseInt(valueSplit[0]) <= dateNow.getHours()) {
                    valueSplit[0] = dateNow.getHours().toString().padStart(2, '0')
                    if (parseInt(valueSplit[1]) <= dateNow.getMinutes()) {
                        valueSplit[1] = dateNow.getMinutes().toString().padStart(2, '0')
                    }
                }
            }

            this.formData.planifiedDate.hours = valueSplit.length > 1 ? valueSplit.join('h') : valueSplit[0].length == 2 ? valueSplit[0]+'h' : valueSplit[0]
            this.calculTimeStampPlanifiedDate()

        },
        ["formData.planifiedDate.date"](newValue, oldValue) {
            if (!newValue || !newValue.length) {
                this.formData.planifiedDate.hours = false
                this.formData.planifiedDate.timestamp = false
            }else{
                //déclencher manuellement le watcher pour eviter une date a inferieur au jour actuel
                this.formData.planifiedDate.hours = this.formData.planifiedDate.hours +''
                this.calculTimeStampPlanifiedDate()
            }


        },
        async ["formData.textContent"](newValue, oldValue) {
            this.formData.urlsTextContent = this.getUrlsContent(newValue)
            
            if (this.timeoutVerifMetaUrl) clearTimeout(this.timeoutVerifMetaUrl)

            this.timeoutVerifMetaUrl = setTimeout(async () => {

                let urlsTextContentValid = []
                for (let url of this.formData.urlsTextContent) {
                    try {
                        const res = await this.getNewsMeta(url);
                        const { success } = res.body;
                        if (success) {
                            urlsTextContentValid.push(url);
                        }
                    } catch (error) {
                        console.error('Echec de la récuperation des metas de l\'url.')
                    }
                }

                this.formData.urlsTextContentHistory = new Set([...urlsTextContentValid, ...this.formData.urlsTextContentHistory]);
            },1000)
        },
        ["formData.files"](newValue, oldValue) {
            this.$emit('saveFormData')
        },
        networkSetting(value) {
            this.$emit('setSelectTypeRenderNetwork', value)
        },
        typeRenderNetworkSelected(value) {
            this.networkSetting = value
        }
        
    },

    beforeDestroy() {
    },

}




</script>